/**
 * Curated executive points of view — LinkedIn posts and Shared Oxygen briefs.
 * Prefer Shared Oxygen URLs when the full brief lives on the site (LinkedIn → sharedoxygen.com).
 */
export const linkedInPointOfViews = [
  {
    id: '1993-1996-same-time',
    title: '2026 Is 1993 And 1996 At The Same Time',
    excerpt:
      'For AI, 2026 is 1996: postings up 88% year over year. For the rest of tech, 2026 is 1993: software postings 23% below February 2020, new-graduate hiring at the largest firms down 65% from 2019. Skills did not die. Skills moved. Cutting the on-ramp is a loan, not a saving. Trained talent is the asset.',
    url: 'https://www.linkedin.com/posts/sharedoxygen_ai-techhiring-workforce-activity-7513740855262945280-CQsG',
    publishedDate: '2026-10-07',
    imageUrl: '/images/1993-1996-same-time-linkedin.png',
    imageAlt: '2026 is 1993 and 1996 at the same time — four sculptures cast a 1993 shadow and a 1996 shadow',
    source: 'LinkedIn',
    author: 'Jeffrey Collins',
  },
  {
    id: 'ai-trust-stack',
    title: 'The AI Stack Is Becoming A Trust Stack',
    excerpt:
      'When AI reaches for the keyboard, intelligence stops being the bottleneck. Trust does. Suggestion ends where commitment begins.',
    url: 'https://sharedoxygen.com/blog/ai-stack-becoming-trust-stack',
    publishedDate: '2026-08-22',
    imageUrl: '/images/blog/ai-trust-stack-linkedin.svg',
    imageAlt: 'Authority at the boundary — suggestion ends where commitment begins',
    source: 'Shared Oxygen',
    author: 'Jeffrey Collins',
  },
];
